import styled from "styled-components";
import colors from "@streeteasy/design-system/deprecated/colors";

const setStrokeColor = props => {
  if (props.isWrapped) {
    return "currentColor";
  }

  return colors[props.strokeColor];
};

const IconWrapper = styled.span`
  box-sizing: border-box;
  display: inline-block;
  line-height: 0;
  padding: ${props => props.desktopPadding};

  @media screen and (max-width: 660px) {
    padding: ${props => props.mobilePadding};
  }

  * {
    box-sizing: border-box;
  }
`;

const SquareFootageWrapper = styled.svg`
  padding: ${props => props.desktopPadding};

  @media screen and (max-width: 660px) {
    padding: ${props => props.mobilePadding};
  }
`;

const SquareFootageOutline = styled.g`
  stroke: ${props => setStrokeColor(props)};
`;

export { IconWrapper, SquareFootageOutline, SquareFootageWrapper };
